import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones. Los 20 idiomas mas hablados del mundo (decision de
// negocio 2026-09-11): en, es, zh, hi, ar, fr, bn, pt, ru, ur, id, de, ja, tr,
// ko, vi, it, th, pl, nl. Todos completos: `node scripts/i18n-parity.js` (corre
// como prebuild) falla si a algun locale le faltan claves o le quedan valores
// copiados del ingles que no esten en scripts/i18n-allowlist.json.
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import bn from './locales/bn.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import ur from './locales/ur.json';
import id from './locales/id.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import tr from './locales/tr.json';
import ko from './locales/ko.json';
import vi from './locales/vi.json';
import it from './locales/it.json';
import th from './locales/th.json';
import pl from './locales/pl.json';
import nl from './locales/nl.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  zh: { translation: zh },
  hi: { translation: hi },
  ar: { translation: ar },
  fr: { translation: fr },
  bn: { translation: bn },
  pt: { translation: pt },
  ru: { translation: ru },
  ur: { translation: ur },
  id: { translation: id },
  de: { translation: de },
  ja: { translation: ja },
  tr: { translation: tr },
  ko: { translation: ko },
  vi: { translation: vi },
  it: { translation: it },
  th: { translation: th },
  pl: { translation: pl },
  nl: { translation: nl },
};

export const SUPPORTED_LANGUAGES = Object.keys(resources);
export const RTL_LANGUAGES = ['ar', 'ur'];

// Aplica direccion de escritura y lang del documento segun el idioma activo.
// Se llama al iniciar y en cada cambio de idioma (ver 'languageChanged' abajo).
function applyDocumentDirection(lng) {
  // Con el idioma ya resuelto (es-ES -> es; un idioma fuera de los 20 -> en, que es
  // lo que de verdad se esta mostrando), no con el codigo crudo detectado.
  const resolved = i18n.resolvedLanguage || lng || 'en';
  const short = resolved.split('-')[0];
  const dir = RTL_LANGUAGES.includes(short) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = short;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // El principal es ingles: es lo que ve un visitante sin preferencia
    // declarada y lo que leen los rastreadores en el HTML estatico (decision
    // de negocio 2026-09-11). Si el idioma detectado no esta entre los 20, cae
    // aqui.
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    // 'languageOnly': el detector normaliza codigos regionales (es-MX, pt-BR,
    // zh-Hans...) a su idioma base antes de resolver, para que el navegador
    // detecte el idioma aunque no tengamos esa variante regional exacta.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => applyDocumentDirection(i18n.resolvedLanguage || i18n.language));

i18n.on('languageChanged', applyDocumentDirection);

export default i18n;
